import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { validateFamilyOwner } from '@/lib/family_validation'
import { setFormData } from '@/store/slices/formDataSlice'
import { createBoundLookupPerson } from '@/lib/person_lookup'
import Modal from '@/components/Modal'
import OwnerInput from '@/components/OwnerInput'

const FamilyStep2Component = ({ onClose }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const formData = useSelector((state) => state.formData)
  const appData = useSelector((state) => state.appData)
  const layout = useSelector((state) => state.layout)
  
  const getOwner = () => {
    return formData.family.members.find((m) => m.owner)
  }

  const [errors, setErrors] = useState({
    phone: false,
  })
  const [valid, setValid] = useState({
    phone: false,
  })
  const [ownerWantsSubscription, setOwnerWantsSubscription] = useState(
    formData.family.hasOwnProperty('ownerWantsSubscription')
      ? formData.family.ownerWantsSubscription
      : true
  )
  const [owner, setOwner] = useState(getOwner() || {
    id: Math.random().toString(),
    verified: false,
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    ssn: '',
    extraAbroad: false,
    extraAbroadId: null,
    twinSim: false,
    dataCard: false,
  })
  
  const capitalizeFirstLetter = (string) => {
    string = string.toLowerCase()
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  
  const boundLookupPerson = createBoundLookupPerson({
    dispatch,
    formData,
    onPersonUpdate: setOwner,
    capitalizeFirstLetter: capitalizeFirstLetter
  })

  const handleChange = (e, resetVerification) => {
    setOwner({
      ...owner,
      verified: resetVerification ? false : owner.verified,
      [e.target.name]: e.target.value,
    })
  }

  const allowNext = () => {
    const family = {
      ...formData.family,
      ownerWantsSubscription: ownerWantsSubscription,
    }

    return validateFamilyOwner(owner, family)
  }

  const prevStep = () => {
    dispatch(setFormData({ familyStep: 'package' }))
  }

  const hasAdults = () => {
    return formData.family.members.filter((m) => m.type === 'adult').length > 0
  }

  const nextStep = () => {
    const members = [...formData.family.members]
    const ownerIdx = members.findIndex((m) => m.owner)
    const firstAdultIdx = members.findIndex((m) => m.type === 'adult')
    const adultMembers = members.filter((m) => m.type === 'adult').length
    const adultCount = formData.family.counts.adult

    if (ownerIdx !== -1) {
      console.log('Has owner..')
      // We have the owner as a member. Does he have subscription? If so, the number of adult members should equal counts
      if (ownerWantsSubscription && adultMembers === adultCount) {
        console.log('Update owner with sub, all good..')
        // All good. Just update subscription.
        members[ownerIdx] = {
          ...owner,
          id: owner.id ? owner.id : Math.random(),
          type: 'adult',
          owner: true,
          set: true,
          subscription: ownerWantsSubscription,
        }
      } else if (ownerWantsSubscription && adultMembers > adultCount) {
        console.log('Remove first adult after owner..')
        // Remove first adult after owner
        if (members[ownerIdx + 1]) {
          members.splice(ownerIdx + 1, 1)
        }
      } else if (!ownerWantsSubscription) {
        // Owner does not have a subscription. Adult members should be one more than count.
        if (adultMembers === adultCount) {
          console.log('Add one adult member..')
          // There are too few members. Add one adult member.
          members.splice(ownerIdx + 1, 0, {
            type: 'adult',
            set: false,
            subscription: true,
            id: Math.random(),
          })
        } else if (adultMembers < adultCount) {
          console.log('Update owner without sub..')
          members[ownerIdx] = {
            ...owner,
            id: owner.id ? owner.id : Math.random(),
            type: 'adult',
            owner: true,
            set: true,
            subscription: ownerWantsSubscription,
          }
        }
      }
    } else {
      if (!ownerWantsSubscription) {
        // Add owner..
        members.unshift({
          ...owner,
          type: 'adult',
          owner: true,
          set: true,
          subscription: ownerWantsSubscription,
          id: Math.random(),
        })
      } else {
        // Update first adult with owner
        members[firstAdultIdx] = {
          ...owner,
          type: 'adult',
          owner: true,
          set: true,
          subscription: ownerWantsSubscription,
        }
      }
    }

    members.sort((a, b) => {
      if (a.owner && !b.owner) {
        return -1
      }

      if (a.type === 'adult' && b.type !== 'adult') {
        return -1
      }
      if (a.type === 'child' && b.type !== 'child') {
        return 1
      }

      return 0
    })

    dispatch(
      setFormData({
        familyStep: 'members',
        family: {
          ...formData.family,
          members: members,
          ownerWantsSubscription: ownerWantsSubscription,
        },
      }),
    )
  }

  const { lookupMethod } = formData

  return (
      <div className="owner-registration-container">
        <h1>Hvem er sjefen?</h1>
        <p>Vi trenger å vite litt mer om den som skal stå som juridisk eier av abonnementene.</p>
        <OwnerInput
          person={owner}
          mode="family"
          handleChange={handleChange}
          ownerWantsSubscription={ownerWantsSubscription}
          onOwnerWantsSubscriptionChange={setOwnerWantsSubscription}
          onPersonUpdate={setOwner}
          lookupPersonFn={boundLookupPerson}
        />
        <div className="buttons">
          <button className="cancel" onClick={prevStep}>
            Tilbake
          </button>
          <button className="continue" disabled={!allowNext()} onClick={nextStep}>
            Fortsett
          </button>
        </div>
        <Modal />
      </div>
  )
}

export default FamilyStep2Component
